import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { Region } from '../models/options/entreprises/region'

const baseResource = 'Entreprises'
const resource = 'Regions'

export default class RegionsResource {
  public async paginatedList(entrepriseId: string, pagenumber?: number, pagesize?: number, search?: string, regionId?: string) : Promise<PaginatedList<Region>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 
    if (regionId && regionId.length) params.append('RegionId', regionId?.toString()); 

    const response = await api.get(`${baseResource}/${entrepriseId}/${resource}`, { params: params } )
    return response.data
  }

  public async delete(entrepriseId: string, id : string) : Promise<Region> {
    const response = await api.delete(`${baseResource}/${entrepriseId}/${resource}/${id}`)
    return response.data
  }

  public async post(entrepriseId: string, data : Region) : Promise<Region> {
    const response = await api.post(`${baseResource}/${entrepriseId}/${resource}`, data)
    return response.data
  }

  public async put(entrepriseId: string, id : string, data : Region) : Promise<Region> {
    const response = await api.put(`${baseResource}/${entrepriseId}/${resource}/${id}`, data)
    return response.data
  }
}
